export const API_URL = "ws://api.d20.link:8080";
